import type { RootState } from '../reducers/index.ts';

export const intentClipboard = (state: RootState) => state.intentClipboardReducer;
